import React from 'react'
import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import exprtise from '../assets/images/icons/expertise.png'
import budget from '../assets/images/icons/budget.png'
import choose from '../assets/images/icons/choose.png'
import solving from '../assets/images/icons/problem-solving.png'
import Footer from '../Footer/footer'
import MaterialTailwindCard from '../shared/Card'



export default function Consulting() {
  return (
    <div>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner" tiitle="Consulting"/>
      <DescBanner text="Our consulting service is designed to guide you through every stage of your project with confidence and clarity. Whether you’re planning a new build, renovating an existing space, or exploring design possibilities, we provide expert advice tailored to your goals.
      We help you make informed decisions about design concepts, materials, budgeting, and timelines—ensuring your project starts on a solid foundation and stays on the right track. With our experience and industry knowledge, we identify potential challenges early and offer practical solutions to avoid delays or costly mistakes.
      Our consulting approach is collaborative, transparent, and focused on turning your ideas into achievable plans while aligning with your budget and vision.
      Let's build your project on the right advice from the very beginning." />
      <div className='mt-24 mb-16'>
      <h1 className="flex justify-center text-center items-center text-2xl md:text-3xl mt-4 mb-4 font-roboto font-bold">Services for consullting</h1>
      <div className='flex justify-center md:justify-between gap-5 p-5 flex-wrap align-middle items-center'>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Project Guidance" desc="Get clear direction and expert advice from the start." img={exprtise}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Material Selection" desc="Choose the right materials for quality and style." img={choose}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Budget Planning" desc="Smart financial planning to keep your project on track." img={budget}/>
        <MaterialTailwindCard imageStyle="p-5" button="hidden" tittle="Problem Solving" desc="Practical solutions to avoid delays and costly mistakes." img={solving}/>
      </div>
      </div>
      <Footer/>
    </div>
    
  )
}
